import { useForm } from "react-hook-form";
import MainContainer from "../../components/container/MainContainer";
import { useState } from "react";
import { useNotification } from "../../components/notification/NotificationContainer";
import InputField from "../../components/form/InputField";
import SelectField from "../../components/form/SelectField";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import {
  getOrganizations,
  unsetOrganizations,
} from "../../features/organizationsSlice";
import { unsetTaskStatuses } from "../../features/taskStatusesSlice";
import { getFirstDate, getTodayDate } from "../../util";
import { useAuthorization } from "../../hooks/useAuthorization";
import {
  getCommunityProjectReports,
  unsetReports,
} from "../../features/reportsSlice";
import { getProjectStatuses } from "../../features/projectStatusesSlice";
import SubmitButton from "../../components/form/buttons/SubmitButton";
import ProjectReportsTable from "../../components/reports/ProjectReportsTable";

const CommunityReports = () => {
  const addNotification = useNotification();
  const dispatch = useDispatch();
  const { isAuthorized } = useAuthorization();
  const user = useSelector((state) => state.user.userInfo);
  const statuses = useSelector((state) => state.projectStatuses.data);
  const organizations = useSelector((state) => state.organizations.data);
  const projects = useSelector((state) => state.reports.projects);
  const loading = useSelector(
    (state) => state.reports.getCommunityProjectReports
  );
  const [activeTab, setActiveTab] = useState("Project Report");

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = async (data, e) => {
    try {
      //
      await dispatch(
        getCommunityProjectReports({
          id: user.community ? user.communities[0].id : null,
          limit: 50,
          offset: 0,
          ...data,
        })
      );
    } catch (error) {
      addNotification(error.message, "warning");
    }
  };

  const renderReportContent = ({ user, projects }) => {
    switch (activeTab) {
      case "Project Report":
        return (
          <ProjectReportsTable
            projects={projects}
            title={user.communities?.[0]?.name || "N/A"}
            loading={loading}
          />
        );
      case "Financial Report":
        return <div>Financial Report Content</div>;
      case "Resource Utilization Report":
        return <div>Resource Utilization Report Content</div>;
      default:
        return <div>Select a report tab to view data</div>;
    }
  };

  useEffect(() => {
    dispatch(getOrganizations({ limit: 200 }));
    dispatch(getProjectStatuses({ limit: 200 }));

    return () => {
      dispatch(unsetOrganizations());
      dispatch(unsetTaskStatuses());
      dispatch(unsetReports());
    };
  }, []);

  return (
    <MainContainer>
      <div className="space-y-4 text-text-1/80">
        <h4 className="font-bold">Community Project Reports</h4>

        {/* Filter Section */}
        <form
          onSubmit={handleSubmit(onSubmit)}
          className="bg-content shadow rounded-lg"
        >
          <div className="bg-content shadow rounded-lg p-4 py-3 grid grid-cols-1 md:grid-cols-5 gap-4">
            <SelectField
              register={register}
              name="status_id"
              label="Status"
              data={[{ id: "", name: "All Statuses" }, ...statuses]}
              errors={errors.status_id}
            />
            {isAuthorized("project_reports", "read") && (
              <SelectField
                register={register}
                name="organization_id"
                label="Country"
                data={[{ id: "", name: "All Countries" }, ...organizations]}
                errors={errors.organization_id}
              />
            )}
            <InputField
              register={register}
              name="start_date"
              label="Start Date"
              autoComplete="off"
              errors={errors.project}
              defaultValue={getFirstDate()}
              type="date"
            />
            <InputField
              register={register}
              name="end_date"
              label="End Date"
              autoComplete="off"
              errors={errors.project}
              defaultValue={getTodayDate()}
              type="date"
            />
            <SubmitButton loading={loading} />
          </div>
        </form>

        {/* Tabs Section */}
        <div>
          <div className="flex border-b">
            {["Project Report"].map((tab) => (
              <button
                key={tab}
                onClick={() => setActiveTab(tab)}
                className={`px-4 py-2 font-medium ${
                  activeTab === tab
                    ? "border-b-2 border-primary text-primary"
                    : "text-text-1/70 hover:text-primary"
                }`}
              >
                {tab}
              </button>
            ))}
          </div>

          {/* Report Content */}
          <div className="mt-6 bg-content shadow rounded-lg p-4">
            {renderReportContent({ user, projects, loading })}
          </div>
        </div>

        {/* Export Buttons */}
        <div className="flex justify-end space-x-4">
          <button
            onClick={() => alert("Export to PDF")}
            className="px-4 py-2 bg-primary text-white/85 rounded-lg shadow hover:bg-primary/80"
          >
            Export to PDF
          </button>
          <button
            onClick={() => alert("Export to Excel")}
            className="px-4 py-2 bg-green-500 text-white/85 rounded-lg shadow hover:bg-green-600"
          >
            Export to Excel
          </button>
        </div>
      </div>
    </MainContainer>
  );
};

export default CommunityReports;
